export default __webpack_public_path__ + "static/O0064-832ae6aa35f124d734ff7c3da66928e7.png";